<template>
	<section>
		<h1>{{ title }}</h1>
		<ul>
			<li v-for="(news, i) in news" :key="`news_${i}`">
				<span class="date">{{ news.date }}</span>
				<h2>{{ news.title }}</h2>
				<div class="excerpt" v-html="news.excerpt"></div>
				<router-link v-if="news.content" :to="news.permalink | clearUrl">
					<span @mouseenter="onPointerMouseEnter($event, 'text')" @mouseleave="onPointerMouseLeave($event, 'text')">{{
						news.more
					}}</span>
				</router-link>
			</li>
		</ul>
		<router-link :to="newsUrl" class="all-news">
			<span @mouseenter="onPointerMouseEnter($event)" @mouseleave="onPointerMouseLeave($event)">{{ allNews }}</span>
		</router-link>
	</section>
</template>

<script>
import { mapState } from "vuex";
import { NewsService } from "@/api";
import pointerHove from "@/mixins/pointerHover";

export default {
	name: "NewsList",
	mixins: [pointerHove],
	computed: {
		...mapState({
			// news: (state) => state.news.all,
			currentLanguage: (state) => state.site.currentLanguage,
			defaultLanguage: (state) => state.site.defaultLanguage,
			strings: (state) => state.site.strings,
		}),
		allNews() {
			return this.strings && this.strings.allNews && this.strings.allNews[this.currentLanguage];
		},
		newsUrl() {
			const lang = this.currentLanguage !== this.defaultLanguage ? "/" + this.currentLanguage : "";
			return `${lang}/news`;
		},
	},
	data() {
		return {
			news: [],
			title: "",
		};
	},
	created() {
		// TODO we should send this request in store and cache all already grabbed data
		this.fetchData();
	},
	mounted() {
		this.addLinksListener();
	},
	updated() {
		this.addLinksListener();
	},
	beforeDestroy() {
		this.removeLinksListener();
	},
	methods: {
		async fetchData() {
			const resp = await NewsService.getNews(this.currentLanguage, 3, 0);
			this.news = resp?.news;
			this.title = resp?.title;
		},
	},
	watch: {
		async currentLanguage(newValue) {
			const resp = await NewsService.getNews(newValue, 3, 0);
			this.news = resp?.news;
			this.title = resp?.title;
		},
	},
};
</script>

<style lang="scss" scoped>
section {
	@include fontCopy;

	h1 {
		@include fontNews;
		text-align: left;
	}

	span.date {
		@include fontCopyS;
		display: inline-block;
		margin-bottom: 10px;
	}

	h2 {
		@include fontCopy;
		font-weight: 500;
	}

	.excerpt {
		@include fontCopy;
		margin-top: 10px;

		&::v-deep p {
			@include fontCopy;

			a {
				transition: color 0.3s;

				&:hover {
					color: $colorRed1 !important;
				}
			}
		}
	}

	a {
		font-weight: 500;
	}

	a.all-news {
		display: inline-block;
		text-align: left;
		background: $colorRed1;
		border-radius: 33% 40% 35% 45% / 60% 60% 60% 60%;
		padding: 5px 15px;
		margin-top: 36px;
		margin-left: -15px;
	}
}

ul {
	list-style: none;
	margin: 0;
	padding: 0;
	text-align: left;
	display: inline-block;
	max-width: 100%;
	width: 100%;

	li {
		margin-top: 50px;
	}

	a {
		margin-top: 10px;
		display: inline-block;
		// @include fontCopy();
		// @include linkUnderline();
		// display: inline-block;
	}
}
</style>
